import React from 'react';
import './paywall-features.m.css'
import { SUBSCRIBER_FEATURES } from '../../../constants';


const PaywallFeatures = () => {
    return (
      <div styleName="sub-footer">
      <div styleName="heading-wrap">
        <img
          src="/icons/left-divider-icon-small.svg"
          styleName="divider-icon"
          className="mobile-only"
        />
        <img
          src="/icons/left-divider-icon.svg"
          styleName="divider-icon"
          className="desktop-only"
        />
        <span styleName="heading">As a Subscriber you get</span>
        <img
          src="/icons/right-divider-icon-small.svg"
          styleName="divider-icon"
          className="mobile-only"
        />
        <img
          src="/icons/right-divider-icon.svg"
          styleName="divider-icon"
          className="desktop-only"
        />
      </div>
      <div styleName="subscriber-get">
        {SUBSCRIBER_FEATURES.map((list) => (
          <div styleName="icon-title">
            <img src={list.url} styleName="sub-icon" alt={list.title} />
            <div styleName="sub-title">{list.title}</div>
            {list.desc === "Bloomberg" ? (
             <div styleName="sub-desc bloomberg"><img src="/icons/bloomberg.svg" alt={list.desc} styleName='bloomberg-icon'/> Stories</div>
            ) : (
              <div styleName="sub-desc">{list.desc}</div>
            )}
            <img
              src="/icons/rhoumbus.svg"
              styleName="rhoumbus-icon"
              height="14px"
              width="14px"
              className="mobile-only"
            />
          </div>
        ))}
      </div>
    </div>
    )
}

export default PaywallFeatures;
